<template>
  <div class="about">
    <div class="banner"
              :style="{ backgroundImage: `url(${banner.img == undefined ?'':domain + banner.img})` }"
    >
      <!-- <img src="../../assets/img/about/bg1.png" alt="" /> -->
    </div>
    <div class="info wrap">
      <div class="caption wow fadeIn">
        <div class="title">
          <div class="title-img">
            <img src="../../assets/img/about/title.png" alt="" />
          </div>
          <div class="c-title">企业简介</div>
          <div class="title-img">
            <img src="../../assets/img/about/title.png" alt="" />
          </div>
        </div>
        <div class="english-title">
          <div class="line"></div>
          <div class="e-title">COMPANY PROFILE</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="info-area">
        <div class="left-info wow fadeInLeft">
          <p>
            {{ form.content }}
          </p>
        </div>
        <div class="info-img wow fadeInRight">
          <img :src="form.img[0].fileUrl == undefined ?'':domain+form.img[0].fileUrl" alt="" />
        </div>
      </div>
    </div>
    <div class="development "
             
    >
     <!-- :style="{ backgroundImage: `url(${domain + form.img[1].fileUrl})` }" -->
      <div class="caption wow fadeIn">
        <div class="title">
          <div class="title-img">
            <img src="../../assets/img/about/title.png" alt="" />
          </div>
          <div class="c-title">发展历程</div>
          <div class="title-img">
            <img src="../../assets/img/about/title.png" alt="" />
          </div>
        </div>
        <div class="english-title">
          <div class="line"></div>
          <div class="e-title">DEVELOPMENT COURSE</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="depImg wow fadeIn">
          <img :src="form.img[1].fileUrl == undefined ?'':domain + form.img[1].fileUrl" alt="" />
        </div>
    </div>
    <div class="honor"
    >
      <div class="wrap">
        <div class="caption wow fadeIn">
          <div class="title">
            <div class="title-img">
              <img src="../../assets/img/about/title.png" alt="" />
            </div>
            <div class="c-title">企业荣誉</div>
            <div class="title-img">
              <img src="../../assets/img/about/title.png" alt="" />
            </div>
          </div>
          <div class="english-title">
            <div class="line"></div>
            <div class="e-title">ENTERPRISE HONOR</div>
            <div class="line"></div>
          </div>
        </div>
        <div class="honor-img wow fadeIn">
          <img :src="form.img[2].fileUrl == undefined ?'':domain + form.img[2].fileUrl" alt="" />
        </div>
      </div>
    </div>
    <div class="honor2 wrap"
    
    >
      <div class="caption wow fadeIn">
        <div class="title">
          <div class="title-img">
            <img src="../../assets/img/about/title.png" alt="" />
          </div>
          <div class="c-title">荣誉证书</div>
          <div class="title-img">
            <img src="../../assets/img/about/title.png" alt="" />
          </div>
        </div>
        <div class="english-title">
          <div class="line"></div>
          <div class="e-title">CERTIFICATE OF HONOR</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="honor2-img wow fadeIn">
        <img :src="form.img[3].fileUrl == undefined ?'':domain + form.img[3].fileUrl" alt="" />
      </div>
    </div>
    <div class="witness"
    
    >
      <div class="wrap">
        <div class="caption wow fadeIn">
          <div class="title">
            <div class="title-img">
              <img src="../../assets/img/about/title.png" alt="" />
            </div>
            <div class="c-title">企业见证</div>
            <div class="title-img">
              <img src="../../assets/img/about/title.png" alt="" />
            </div>
          </div>
          <div class="english-title">
            <div class="line"></div>
            <div class="e-title">CORPORATE WITNESS</div>
            <div class="line"></div>
          </div>
        </div>
        <div class="witness-img wow fadeIn">
          <img :src="form.img[4].fileUrl == undefined ?'':domain + form.img[4].fileUrl" alt="" />
        </div>
      </div>
    </div>
    <div class="partner wrap"
    >
      <div class="caption wow fadeIn">
        <div class="title">
          <div class="title-img">
            <img src="../../assets/img/about/title.png" alt="" />
          </div>
          <div class="c-title">合作伙伴</div>
          <div class="title-img">
            <img src="../../assets/img/about/title.png" alt="" />
          </div>
        </div>
        <div class="english-title">
          <div class="line"></div>
          <div class="e-title">BUSINESS PARTNER</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="partner-img wow fadeIn">
        <img :src="form.img[5].fileUrl == undefined ?'':domain + form.img[5].fileUrl" alt="" />

      </div>
    </div>
    <div class="connect wrap"
    >
      <div class="caption wow fadeIn">
        <div class="title">
          <div class="title-img">
            <img src="../../assets/img/about/title.png" alt="" />
          </div>
          <div class="c-title">欢迎与我们联系</div>
          <div class="title-img">
            <img src="../../assets/img/about/title.png" alt="" />
          </div>
        </div>
        <div class="english-title">
          <div class="line"></div>
          <div class="e-title">我们期待与您交流</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="connect-area wow fadeIn">
        <div class="phone">
          <div class="phone-top">
            <div class="phone-item">
              <div class="icon">
                <img src="../../assets/img/about/local.png" alt="" />
              </div>
              <div>{{ form.local }}</div>
            </div>
            <div class="phone-item">
              <div class="icon">
                <img src="../../assets/img/about/phone.png" alt="" />
              </div>
              <div>{{ form.phone }}</div>
            </div>
          </div>
          <div class="ewm">
            <div class="ewm-img">
              <img :src="form.img[6].fileUrl == undefined ?'':domain+form.img[6].fileUrl" alt="" />
            </div>
            <div class="ewm-text">关注我们</div>
          </div>
        </div>
        <div class="gaode" id="gao-de-map"></div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>

import AMapLoader from "@amap/amap-jsapi-loader";
import { BASEDOMAIN } from "../../common/config";
import { aboutUs ,banner} from "../../network/http_api";
import Footer from "../../components/footer.vue";
export default {
  data() {
    return {
      domain: "",
      banner:'',
      map: null,
      form: {
        id: "",
        content: "",
        local: "",
        phone: "",
        x_local: 0,
        y_local: 0,
        img: [
          {
            //   企业简介图片
            //预览图-B64
            fileUrl: "",
          },
          {
            //   发展历程图片
            //预览图-B64
            fileUrl: "",
          },
          {
            //   企业荣誉图片
            //预览图-B64
            fileUrl: "",
          },
          {
            //   荣誉证书图片
            //预览图-B64
            fileUrl: "",
          },
          {
            //   企业见证图片
            //预览图-B64
            fileUrl: "",
          },
          {
            //   合作伙伴图片
            //预览图-B64
            fileUrl: "",
          },
          {
            //   二维码
            //预览图-B64
            fileUrl: "",
          },
        ],
      },
    };
  },
  components: {
    Footer,
  },
  mounted() {
    this.domain = BASEDOMAIN;
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", () => {
      history.pushState(null, null, document.URL);
    });
    this.$nextTick(() => {
      this.$wow.init();
    });
    this.initMap();
    this.getData();
    this.getBanner()
  },
  methods: {
     async getBanner() {
      let res = await banner(5);
      if (res.code == 200) {
        this.banner = res.data[0];
        //console.log("banner", res.data);
      } else {
        this.$message.error(res.msg);
      }
      //console.log("banner", res);
    },
    async getData() {
      let res = await aboutUs();
      if (res.code == 200) {
        let enterprise_profile = JSON.parse(res.data.enterprise_profile);
        let development_history = JSON.parse(res.data.development_history);
        let enterprise_honor = JSON.parse(res.data.enterprise_honor);
        let certificate_honor = JSON.parse(res.data.certificate_honor);
        let corporate_witness = JSON.parse(res.data.corporate_witness);
        let partner = JSON.parse(res.data.partner);
        let about_us = JSON.parse(res.data.about_us);
        this.form = {
          id: res.data.id,
          content: enterprise_profile.content,
          local: about_us.address,
          phone: about_us.phone,
          x_local: about_us.coordinate_x,
          y_local: about_us.coordinate_y,
          img: [
            {
              //   企业简介图片
              //预览图-B64
              fileUrl: enterprise_profile.img,
            },
            {
              //   发展历程图片
              //预览图-B64
              fileUrl: development_history.img,
            },
            {
              //   企业荣誉图片
              //预览图-B64
              fileUrl: enterprise_honor.img,
            },
            {
              //   荣誉证书图片
              //预览图-B64
              fileUrl: certificate_honor.img,
            },
            {
              //   企业见证图片
              //预览图-B64
              fileUrl: corporate_witness.img,
            },
            {
              //   合作伙伴图片
              //预览图-B64
              fileUrl: partner.img,
            },
            {
              //   二维码
              //预览图-B64
              fileUrl: about_us.img,
            },
          ],
        };
        //console.log("form", this.form);
      } else {
        this.$message.error(res.msg);
      }
      //console.log("aboutUs", res);
    },
    initMap() {
      AMapLoader.load({
        key: "395a4388a68576fbb553b0e82c5ddf57", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale", "AMap.ToolBar", "AMap.ControlBar"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map("gao-de-map", {
            //设置地图容器id
            resizeEnable: true,
            viewMode: "2D", //是否为3D地图模式
            zoom: 20, //初始化地图级别
            center: [this.form.x_local*1, this.form.y_local*1], //初始化地图中心点位置（北京）
            // 116.397428, 39.90923
            // 121.36837,30.746511
          });
//console.log('this.form.x_local, this.form.y_local',this.form.x_local, this.form.y_local);
          this.map.addControl(new AMap.Scale()); // 添加左下角的比例尺
          let toolBar = new AMap.ToolBar({
            position: {
              bottom: "20px",
              right: "35px",
            },
          });
          let controlBar = new AMap.ControlBar({
            position: {
              bottom: "100px",
              right: "10px",
            },
          });
          this.map.addControl(toolBar); // 添加右下角的放大缩小
          //   this.map.addControl(controlBar); // 方向盘
          let marker = new AMap.Marker({
            icon: "", //图片ip
            imageSize: "20px",
            position: [this.form.x_local*1, this.form.y_local*1],
            offset: new AMap.Pixel(-13, -30),
            // 设置是否可以拖拽
            draggable: false,
            // 设置拖拽效果
            raiseOnDrag: true,
          });
          marker.setMap(this.map);
          //    <div class="logo">
          //                     <img src="../../assets/img/logo@2x.png" alt="">
          //                 </div>
          let infoWindow = new AMap.InfoWindow({
            content: `<div class="mark-text" style="min-width: 250px;">
                <div class="company-title" style="font-size: 18px;
                font-weight: 600;
                margin-bottom: 5px;">鸢飞信息科技</div>
                <div class="company-local">${this.form.local}</div>
            </div>`, //使用默认信息窗体框样式，显示信息内容
          });
          // 121.368355, 30.746585
          infoWindow.open(this.map, [(this.form.x_local*1)-0.000015, (this.form.y_local*1)+0.000074]);
          infoWindow.setMap(this.map);
          marker.on("click", function () {
            infoWindow.open(this.map, marker.getPosition());
          });
        })
        .catch((e) => {
          //console.log(e);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.amap-marker-label {
  border: 0;
  background-color: transparent;
}
.mark-text {
  width: 250px;
  .logo {
    height: 40px;
    margin-bottom: 10px;
    img {
      height: 100%;
    }
  }
  .company-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 5px;
  }
  .company-local {
  }
}
.about {
  //   margin-top: 64px;
  .wrap {
    width: 1200px;
    margin: 0 auto;
  }
  .caption {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 428px;
    text-align: center;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    margin-left: 50%;
    transform: translateX(-50%);
    .title {
      display: flex;
      width: 100%;
      justify-content: space-between;
      font-size: 40px;
      font-weight: 500;
      color: #202020;
      line-height: 47px;
      margin-bottom: 8px;
      .title-img {
        width: 40px;
        img {
          width: 100%;
        }
      }
      .c-title {
        // margin: 0 100px;
      }
    }
    .english-title {
      display: flex;
      align-items: center;
      justify-content: center;
      .e-title {
        font-size: 14px;
        color: #d8d8d8;
        margin: 0 26px;
      }
      .line {
        width: 76px;
        height: 1px;
        background: #d2d2d2;
      }
    }
  }
  .banner {
    height: 100vh;
    background: url(" ") no-repeat;
    background-size: cover;
  }
  .info {
    margin-bottom: 106px;
    padding-top: 51px;
    .info-area {
      display: flex;
      justify-content: space-between;
      margin-top: 66px;
      .left-info {
        width: 535px;
        height: 375px;
        font-size: 16px;
        color: #606266;
        line-height: 24px;
        .center {
          margin: 10px 0;
        }
      }
      .info-img {
        width: 560px;
        height: 354px;
        img {
          width: 100%;
        }
      }
    }
  }
  .development {
    // height: 689px;
    width: 1200px;
    margin: 0 auto;
    background: url("") no-repeat;
    background-size: 100%;
    .depImg {
      width: 1200px;
      margin-bottom: -4px;
      img {
        width: 100%;
      }
    }
  }
  .honor {
    padding-top: 46px;
    background: #f5f5f5;
    padding-bottom: 60px;
    .honor-img {
      margin-top: 31px;
      margin-left: 50%;
      transform: translateX(-50%);
      width: 1200px;
      img {
        width: 100%;
      }
    }
  }
  .honor2 {
    width: 1550px;
    // height: 800px;
    padding-top: 72px;
    background: url("") no-repeat center center;
    background-size: cover;
    padding-bottom: 67px;
    .honor2-img {
      margin-top: 31px;
      margin-left: 50%;
      transform: translateX(-50%);
      width: 1200px;
      img {
        width: 100%;
      }
    }
  }
  .witness {
    padding-top: 45px;
    padding-bottom: 70px;
    background: #f5f5f5;
    .witness-img {
      margin-top: 62px;
      width: 1200px;
      img {
        width: 100%;
      }
    }
  }
  .partner {
    padding-top: 96px;
    .partner-img {
      margin-top: 77px;
      width: 1200px;
      img {
        width: 100%;
      }
    }
  }
  .connect {
    padding-top: 123px;
    margin-bottom: 73px;
    .connect-area {
      display: flex;
      justify-content: space-between;
      margin-top: 85px;
      .phone {
        .phone-top {
          .phone-item {
            display: flex;
            font-size: 24px;
            font-weight: 500;
            color: #202020;
            line-height: 28px;
            margin-bottom: 10px;
            .icon {
              width: 24px;
              margin-right: 12px;
              img {
                width: 100%;
              }
            }
          }
        }
        .ewm {
          margin-top: 83px;
          .ewm-img {
            width: 148px;
            img {
              width: 100%;
            }
          }
          .ewm-text {
            font-size: 18px;
            font-weight: 400;
            color: #606266;
            line-height: 21px;
            width: 148px;
            text-align: center;
          }
        }
      }
      .gaode {
        width: 683px;
        height: 363px;
      }
    }
  }
}
</style>